import { Col, Row } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const WarehouseMutateFormTemplate = () => {
  return (
    <Row>
      <Col md="8">
        <CrudPlaceholderInput name="name" />
      </Col>
      <Col md="8">
        <CrudPlaceholderInput name="code" />
      </Col>
      <Col md="8">
        <CrudPlaceholderInput name="calloff_rule" />
      </Col>
    </Row>
  );
};
